import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { useSettings, digits } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const wa = digits(settings.whatsapp_number);
  return (
    <footer className="mt-20 border-t hairline bg-muted/30" data-testid="site-footer">
      <div className="container-x py-14 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <div className="mb-4">
            <Logo size="lg" linkTo={null} />
          </div>
          <p className="text-sm text-muted-foreground max-w-sm">
            Brass · Bronze · German Silver · Rudraksha · Pooja · Spiritual · Home &amp; Temple Décor. Thoughtfully sourced Indian handcrafts. Prepaid orders only.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="https://www.instagram.com/the_adiyogi_spiritual" target="_blank" rel="noopener noreferrer" className="w-11 h-11 border hairline rounded-full flex items-center justify-center hover:gold-text transition" data-testid="social-instagram" aria-label="Instagram"><Instagram className="w-4 h-4" strokeWidth={1.5} /></a>
            <a href="#" className="w-11 h-11 border hairline rounded-full flex items-center justify-center hover:gold-text" data-testid="social-facebook" aria-label="Facebook"><Facebook className="w-4 h-4" strokeWidth={1.5} /></a>
            <a href="#" className="w-11 h-11 border hairline rounded-full flex items-center justify-center hover:gold-text" data-testid="social-youtube" aria-label="YouTube"><Youtube className="w-4 h-4" strokeWidth={1.5} /></a>
            {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="w-11 h-11 border hairline rounded-full flex items-center justify-center hover:gold-text" data-testid="social-whatsapp" aria-label="WhatsApp"><MessageCircle className="w-4 h-4" strokeWidth={1.5} /></a>}
          </div>
        </div>
        <div>
          <div className="font-serif text-lg mb-3">Quick Links</div>
          <ul className="text-sm space-y-2 text-muted-foreground">
            <li><Link to="/" className="hover:gold-text">Home</Link></li>
            <li><Link to="/shop" className="hover:gold-text">Shop</Link></li>
            <li><Link to="/about" className="hover:gold-text">About Us</Link></li>
            <li><Link to="/contact" className="hover:gold-text">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-serif text-lg mb-3">Categories</div>
          <ul className="text-sm space-y-2 text-muted-foreground">
            <li><Link to="/shop?category=pooja-items" className="hover:gold-text">Pooja Items</Link></li>
            <li><Link to="/shop?category=housewarming" className="hover:gold-text">Housewarming</Link></li>
            <li><Link to="/shop?category=brass-collection" className="hover:gold-text">Brass</Link></li>
            <li><Link to="/shop?category=bronze-collection" className="hover:gold-text">Bronze</Link></li>
            <li><Link to="/shop?category=german-silver-collection" className="hover:gold-text">German Silver</Link></li>
            <li><Link to="/shop?category=gift-collection" className="hover:gold-text">Gifts</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-serif text-lg mb-3">Head Offices</div>
          <ul className="text-xs space-y-3 text-muted-foreground">
            <li>
              <div className="text-espresso font-medium">Mumbai</div>
              Madame Cama Rd, Dr Ambedkar Statue Chowk Area, Colaba, Mumbai, Maharashtra 400001
            </li>
            <li>
              <div className="text-espresso font-medium">Coimbatore</div>
              Velliangiri Foothills, Mahashivaratri Grounds, Ishana Vihar, Coimbatore, Tamil Nadu 641114
            </li>
            <li className="pt-2 flex items-center gap-2">
              <span aria-hidden="true">🚚</span>
              <span>All Over India Delivery · <span className="text-espresso">Fast &amp; Secure</span></span>
            </li>
          </ul>
        </div>
        <div>
          <div className="font-serif text-lg mb-3">Support</div>
          <ul className="text-sm space-y-2 text-muted-foreground">
            <li><Link to="/track" className="hover:gold-text">Track Order</Link></li>
            <li><Link to="/policies/shipping" className="hover:gold-text">Shipping Policy</Link></li>
            <li><Link to="/policies/returns" className="hover:gold-text">Returns &amp; Refunds</Link></li>
            <li><Link to="/policies/privacy" className="hover:gold-text">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:gold-text">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t hairline">
        <div className="container-x py-5 text-xs text-muted-foreground flex flex-col md:flex-row items-center justify-between gap-2" data-testid="footer-bottom">
          <div>© {new Date().getFullYear()} AdiYogi Handcrafts. Crafted with devotion in India.</div>
          <div className="inline-flex items-center gap-1.5" data-testid="footer-karnataka">
            <span aria-hidden="true">🇮🇳</span>
            <span>AdiYogi Handcrafts — A Karnataka Government Initiative</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
